<template>
  <div>
    <base-drawer :open="open" :close="close" title="Pagamento realizado">
      <base-card>
        <div class="success-container d-flex align-center">
          <img src="@/assets/img/module_store/success.png" class="col-xs-8 pt_25 my_30" />
          <div class="success-text mt_10 col-xs-8">
            <p>Pagamento realizado com sucesso!</p>
            <p>
              <br />
            </p>
            <p>Este módulo acaba de ser adicionado a sua assinatura.</p>
          </div>
        </div>
        <div class="mt_10 py_30 d-flex justify-center">
            <div class="col-xs-8 d-flex align-stretch success-link-container">
                <base-button text="IR PARA MINHA CONTA" @click="goToMyAccount"/>
            </div>
        </div>
      </base-card>
    </base-drawer>
  </div>
</template>
<script>
import BaseAdd from "@/components/Add";
import BaseDrawer from "@/components/Drawer";
import BaseButton from "@/components/Button";
import BaseCard from "@/components/Card";
import router from '@/router'

export default {
  components: { BaseAdd, BaseDrawer, BaseButton, BaseCard },
  props: {
    open: { type: Boolean, default: false },
    close: { type: Boolean, default: false }
  },
  methods: {
      goToMyAccount() {
          router.push("minha-conta")
      }
  }
};
</script>
<style scoped>

.success-container {
  flex-direction: column;
}

.success-link-container .btn {
    flex: 1
}

.success-text p {
  text-align: center;
  font: normal normal 300 16px/19px Lato;
  letter-spacing: 0px;
  color: #999999;
  opacity: 1;
}
</style>